

<template>
	<section class="clearfix">
		<compWrapper :title="$t('fbb.accountmanage.auth_menu', { defaultValue: '权限菜单' })" theme="primary" class="pull-left width-45per">
			<componentNode class="margin-left-15 margin-top-15" ref="nodedata" @on-data="getNodeData"/>
		</compWrapper>
			<compWrapper  v-if="showlevel1" :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary" class="pull-right width-50per">
                <!-- 新增/编辑费用项 -->
                <div class="margin-20">
                    <vForm :label-width="100" ref="applicateform" >
                        <compFormEdit :formdata="getTow" v-model="formData" ref="formtow" class="margin-15"></compFormEdit>
                    </vForm>

                    <footer class="text-center" >
                        <vButton theme="primary" @click="getnewCode" class="margin-right-15">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
                        <vButton @click="cancel">{{$t('global.common.reset', { defaultValue: '重置' })}}</vButton>
                    </footer>
                </div>
			</compWrapper>

            <div v-if="showlevel2" class="pull-right width-50per" >
                <componentProject :dataone="formData"></componentProject>
            </div>


        <!-- 全局弹框 -->
        <compModal
        v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show=false"
        >
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" ></component>
        </compModal>

		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import componentNode from './node';
import componentProject from './project';
import { HttpSaveBillingCategoryOne, HttpCreateBillingCategoryOne, HttpDeleteBillingCategoryOne } from '@/service/newbigaccount';
import { mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		componentNode,
        componentProject
	},
	data() {
		return {
			isSystem: false,
			loading: false,
            formData: {
                billingChannels:[]
            },
            showlevel1:false,
            showlevel2:false,
            level:0,
            costline:'',
            modalProps:{
                show:false,
                title:"",
                component: null
            },
		};
	},
	computed: {
        getTow(){
            return [
                {
					label: "计费项目",
                    key: "name",
                    tag: "Input",
                },
                {
					label:'使用范围',
					tag: "vCheckBox",
					key: "billingChannels",
					options: [{
						trueValue: 'RECEIVABLE',
						label: '应收'
					}, {
						trueValue: 'PAYABLE',
						label: '应付'
					}],
					span: 24,
				},
            ]
        }
	},
	created() {

	},

	methods: {
		cancel() {
			this.formData = {};
			this.$refs.form.resetFields();
		},
		// ...mapActions('ucadm',['actionBase']),
		getNodeData(data = {}, edittype) {
            // console.log(data,edittype)
            if(edittype=="add"){
                this.formData.name = '';
                this.formData.billingChannels = [];
                this.showlevel1 = true;
                this.showlevel2 = false;
            }else if(edittype=="edit"){
                let { name, id, billingChannels } = data;
                this.formData = { name, id, billingChannels }
                this.showlevel1 = true;
                this.showlevel2 = false;
            }else if(edittype=="delete"){
                let { name, id, billingChannels } = data;
                this.formData = { name, id, billingChannels }
                this.modalProps = {
                    show: true,
                    alert: "error",
                    title: "删除节点",
                    width: 460,
                    showDesc:true,
                    desc:'删除后不可恢复，请确认是否删除',
                    params:{id:this.formData.id},
                    ajaxRequest:HttpDeleteBillingCategoryOne,
                    callback:()=>{
                        this.modalProps.show = false;
                        this.$refs.nodedata.update();
                        this.showlevel1 = false;
                        this.showlevel2 = false;
                        this.formData.name = ''
                        this.formData.billingChannels = []
                    }
                };
            }else if(edittype=="setting"){
                let { name, id, parentId, expenseCategoryType, billingChannels } = data;
                this.formData = {  name, id, parentId, expenseCategoryType, billingChannels }
                this.showlevel1 = false;
                this.showlevel2 = true;
            }
            this.operateType = edittype;
			if (edittype === 'add') {
                this.level = parseInt(data.level+1)
                this.formData.parentId = data.id
                return
            };
			// if (edittype === 'edit') {
            //     console.log(data)
            //     this.formData.id = data.id;
            //     this.level = data.level
			// }
        },
        async getnewCode(){
            if(this.operateType === 'add'){
                if(this.showlevel1 == true){
                    let vaild1 = await this.$refs.formtow.validate();
                    if (!vaild1) return;
                }
                HttpCreateBillingCategoryOne({
                    parentId:this.formData.parentId,
                    name:this.formData.name,
                    billingChannels: this.formData.billingChannels
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.$refs.nodedata.update();
                    this.showlevel1 = false;
                    this.showlevel2 = false;
                    this.formData.name = '';
                    this.formData.billingChannels = []
                },err=>{
                    this.$VMessage.error(err.message);
                })
            }else{
                if(this.showlevel1 == true){
                    let vaild1 = await this.$refs.formtow.validate();
                    if (!vaild1) return;
                }
                HttpSaveBillingCategoryOne({
                    id:this.formData.id,
                    name:this.formData.name,
                    billingChannels: this.formData.billingChannels.join(',')
                }).then(res=>{
                    if(res.statusCode == 200){
                        this.$VMessage.success('操作成功');
                    }
                    this.$refs.nodedata.update()
                    // this.showlevel1 = false;
                    // this.showlevel2 = false;
                    // this.formData.name = ''
                    // this.formData.billingChannels = []
                },err=>{
                    this.$VMessage.error(err.message);
                })
            }

        },
		async updateMenu() {

            if(this.showlevel2 == true){
                let vaild2 = await this.$refs.formtow.validate();
                if (!vaild2) return;
            }
            this.loading = true;
            this.formData.level = this.level
            await HttpSaveCategoryOne(this.formData).then(res=>{
                this.$VMessage.success(res.message);
                this.$store.dispatch('dictionary/actionBillcategory',true)
            },err=>{
                this.$VMessage.error(err.message);
            })

			this.loading = false;
		},
	},
};
</script>
